import DeliveryPointsModal, { DeliveryPoint } from '../DeliveryPointsModal'
import DeliveryCourier from './DeliveryCourier'
import { useHistory } from 'react-router-dom'
import DefaultView from './DefaultView'
import React, { useState } from 'react'
import Popup from '../Popup'
import { v7 } from 'uuid'
import './style.scss'

export const basicDelivery = ({
  id: '',
  deliveryMethodId: '',
  type: ''
}) as unknown as payments.Delivery

interface DeliveryPopupProps {
  productName: string
  price: string
  delivery?: payments.Delivery
  popupName?: string
  additionalText?: string
  placeAddress?: string
  cancelAction: basic.BasicFunc
  deliveryMethods: payments.DeliveryMethod[]
  callback: (_: { deliveryId: string }) => void
  recentlySelectedDeliveries: payments.Delivery[]
  setRecentlySelectedDeliveries: React.Dispatch<React.SetStateAction<payments.Delivery[]>>
}

const DeliveryPopup: React.FC<DeliveryPopupProps> = ({ delivery: initDelivery, popupName, additionalText, placeAddress, recentlySelectedDeliveries, cancelAction, deliveryMethods, productName, price, callback, setRecentlySelectedDeliveries }) => {
  const [isEditable, setEditable] = useState(!recentlySelectedDeliveries?.[0])
  const [delivery, setDelivery] = useState<payments.Delivery>(initDelivery || recentlySelectedDeliveries?.[0] || basicDelivery)

  const { goBack } = useHistory()

  const saveDelivery = (point?: DeliveryPoint) => {
    const deliveryId = delivery.id || v7()
    if (!delivery.id) {
      const newDelivery: payments.Delivery = { ...delivery, id: deliveryId }
      if (point?.id) {
        newDelivery.pointId = point.id
        newDelivery.shippingCarrier = point.service
      }
      setRecentlySelectedDeliveries(prev => [...prev, newDelivery])

    } else {
      setRecentlySelectedDeliveries(prev => {
        return prev.reduce((r, d) => {
          d.id === deliveryId ? r.unshift(d) : r.push(d)
          return r
        }, [] as payments.Delivery[])
      })
    }
    callback({ deliveryId })
  }

  return (
    <Popup
      darkBg={true}
      close={cancelAction || goBack}>
      {(() => {
        const renderDefaultView = () => {
          return <DefaultView
            price={price}
            delivery={delivery}
            popupName={popupName}
            productName={productName}
            setEditable={setEditable}
            setDelivery={setDelivery}
            saveDelivery={saveDelivery}
            cancelAction={cancelAction}
            additionalText={additionalText}
            deliveryMethods={deliveryMethods}
            recentlySelectedDeliveries={recentlySelectedDeliveries}
          />
        }

        if (!isEditable) return renderDefaultView()
        switch (delivery.type) {
          case 'courier':
            return <DeliveryCourier
              delivery={delivery}
              fields={deliveryMethods.find(d => d.deliveryMethodKey === 'courier')?.fields}
              saveDelivery={saveDelivery}
              setDelivery={setDelivery}
            />

          case 'magbox':
          case 'delivery_point':
            return <DeliveryPointsModal
              showModal={false}
              placeAddress={placeAddress}
              initialServices={delivery.type === 'magbox' ? ['mm'] : undefined}
              close={saveDelivery}
              uncheckDelivery={() => {
                setDelivery(basicDelivery)
              }}
            />

          case 'code_locker':
            return <div>Not supported</div>

          default:
            return renderDefaultView()
        }
      })()}
    </Popup>
  )
}

export default DeliveryPopup